import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB7Bz0wOecie-AMO7uuws7jf1dYA33jdj0",
  authDomain: "x-clone-86c4b.firebaseapp.com",
  projectId: "x-clone-86c4b",
  storageBucket: "x-clone-86c4b.firebasestorage.app",
  messagingSenderId: "573628679089",
  appId: "1:573628679089:web:91cb419bd59c98775d3390"
};

const app = initializeApp(firebaseConfig);
// Version9の書き方  Version8 →　const db = firebaseApp.firestore()
const db = getFirestore(app);

export default db;